<template>
<svg viewBox="0 0 20 20" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-idea`]" width="1em" height="1em" v-bind="$attrs"><path d="M11.907 17.9995C11.5677 18.7127 10.8422 19.2065 9.99982 19.2065C9.15759 19.2064 8.43195 18.7126 8.09259 17.9995H8.01154C7.45925 17.9995 7.01154 17.5518 7.01154 16.9995V15.231C7.01154 15.0929 7.12346 14.981 7.26154 14.981H12.7381C12.8762 14.981 12.9881 15.0929 12.9881 15.231V16.9995C12.9881 17.5518 12.5404 17.9995 11.9881 17.9995H11.907ZM9.99982 0.793457C13.6674 0.793457 16.6403 3.76654 16.6404 7.43408C16.6404 9.25744 15.9063 10.9098 14.7166 12.1099C14.1346 12.6969 13.5399 13.2978 13.0643 13.9673C13.0165 14.0345 12.9398 14.0756 12.8572 14.0757H7.14337C7.06086 14.0756 6.98414 14.0345 6.93634 13.9673C6.46076 13.2978 5.86602 12.6969 5.284 12.1099C4.09421 10.9097 3.35919 9.25753 3.35919 7.43408C3.35936 3.76656 6.33227 0.793497 9.99982 0.793457Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillIdea',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
